import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useProgramPanel } from 'contexts/programPanelContext';
import { ProgramBaseConfig } from './panels/program-base';
import { ProgramRecruitment } from './panels/recruitment';
import { ProgramPairs } from './panels/pairs';
import { ProgramAdditionalSettings } from './panels/additional-settings';
import { ProgramContentConfig } from './panels/program-content';

const ProgramConfig = () => {
	const { t } = useTranslation();

	const { refetch, isStale } = useProgramPanel();

	useEffect(() => {
		if (isStale) {
			refetch?.();
		}
	}, []);

	return (
		<>
			<Helmet title={t('organizationPanel.programDashboard')} />
			<div className="flex flex-row flex-wrap">
				<div className="flex flex-column gap-4 col-12 xl:col-6">
					<ProgramBaseConfig />
					<ProgramContentConfig />
					<ProgramRecruitment />
				</div>
				<div className="flex flex-column gap-4 col-12 xl:col-6">
					<ProgramPairs />
					<ProgramAdditionalSettings />
				</div>
			</div>
		</>
	);
};

export default ProgramConfig;
